import { z } from "zod";

const DIGIT_REGEX = /\d/;

export const checkBlacklistSchema = z
  .object({
    nricNumber: z
      .string()
      .transform((value) => value.replace(/[^a-zA-Z0-9]/g, ""))
      .refine((value) => value.length > 0, {
        message: "IC Number / Passport Number is required",
      })
      .refine((value) => DIGIT_REGEX.test(value), {
        message: "IC Number / Passport Number must include at least 1 digit",
      }),
    hasExistingServiceProvider: z.boolean(),
    existingServiceProvider: z.string().optional(),
    existingServiceNumber: z.string().optional(),
  })
  .superRefine((data, context) => {
    if (data.hasExistingServiceProvider) {
      if (!data.existingServiceProvider) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Existing Service Provider is required",
          path: ["existingServiceProvider"],
        });
      }

      if (!data.existingServiceNumber) {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Existing Service Number is required",
          path: ["existingServiceNumber"],
        });
      }
    }
  });
